import type { ScheduleStatusKey } from "./theme";

// Collapse a visit's raw `status` + `missedVisit` flag into one of the six
// schedule display states (see `scheduleStatusMeta` in theme.ts).
//
// Rules (mirrors the nurse-facing status spec):
//   - `missedVisit` ALWAYS wins — a missed visit shows only "Missed", whatever
//     its underlying lifecycle status is (same regression guard as
//     `computeVisitState`: a missed visit keeps status=in_progress).
//   - `completed`, `sealed`, `under_review`, `pending_correction` all read
//     "Completed" — finished is finished; sealed is just locked & final.
//   - `in_progress` and `post_processing` ("finishing up") read "In progress".
//   - `assigned` (and the defensive default) read "Scheduled".
//
// Pending visit *requests* (offers the nurse made, awaiting agency approval)
// are a different entity and are mapped to the "pending" key by the caller —
// they never flow through this function.
export function getScheduleStatus(status: string, missedVisit: boolean): ScheduleStatusKey {
    if (missedVisit) {
        return "missed";
    }
    switch (status) {
        case "cancelled":
            return "cancelled";
        case "in_progress":
        case "post_processing":
            return "in_progress";
        case "completed":
        case "sealed":
        case "under_review":
        case "pending_correction":
            return "completed";
        case "assigned":
        case "pending":
        default:
            return "scheduled";
    }
}
